import BFEGraphic from '../assets/base-flood-elevation-bfe.svg';

import BaseFloodElevationBox from './BaseFloodElevationBox';

const FFElevation = ({
  baseFloodElevation = null,
  firstFloorElevation = null,
  propertyId = null,
  coordinates = null,
  ecFlag = null,
  reportPage = false,
}) => {
  return (
    <div>
      <p className="text-xs text-rain sm:text-sm">
        Buyers Aware assesses the risk to the property, not necessarily the structure(s). One
        important characteristic that cannot be easily accounted for is what is referred to as First
        Floor Elevation (FFE). The FFE refers to the height of the floor above a reference point,
        often measured in relation to the base flood elevation (BFE). It indicates how high the
        lowest habitable floor of a building is situated above the potential floodwaters.
      </p>
      <div className="flex justify-center">
        <img
          className="w-full max-w-2xl"
          alt="Graphic of residence below, at, and above base flood elevation"
          src={BFEGraphic}
        />
      </div>
      <div className="mt-4 bg-white">
        <BaseFloodElevationBox
          baseFloodElevation={baseFloodElevation}
          firstFloorElevation={firstFloorElevation}
          propertyId={propertyId}
          coordinates={coordinates}
          ecFlag={ecFlag}
          reportPage={reportPage}
        />
      </div>
      <p className="mt-4 text-xs text-rain sm:text-sm">
        Freeboard is the added margin above the base flood elevation that determines how much
        protection a structure actually has when water reaches that level. For example, two homes on
        the same street may sit at the same ground elevation, but face very different flood risk.
        One is a newer home built with a pier-and-beam foundation, its first floor is raised 3 feet
        above the BFE; this extra buffer is called freeboard. During a flood event that reaches the
        BFE, that home's living space stays dry. The other home is older and was built with a slab
        foundation at or just below the BFE. During the same event, floodwater would enter the
        living space of the home on the ground. Knowing a property's elevation relative to the BFE
        is most meaningful when paired with an understanding of the underlying flood risk itself.
      </p>
    </div>
  );
};

export default FFElevation;
